const NAV_ITEMS = [
  { href: "#stats", label: "KPIs Gerais" },
  { href: "#sales", label: "Vendas" },
  { href: "#financeiro", label: "Operação" },
];

const DashNav = () => (
  <div className="dash-v2-nav">
    <nav className="d-flex" style={{ overflowX: "auto" }}>
      {NAV_ITEMS.map((item) => (
        <a key={item.href} href={item.href} className="dash-v2-nav-link">
          {item.label}
        </a>
      ))}
    </nav>
  </div>
);

export default DashNav;
